/*
 * Guest signed-link transfer landing — `/transfer/:token` (PROJ-0078-WU-10,
 * decision (c) ratified in BOARDROOM-2026-09-27-191409: my.trumin hosts it).
 * Public, matched before the auth gate like `/claim/:token`, and only when
 * VITE_TRANSFER_ENABLED is on (App.tsx).
 *
 * WHAT THE LINK IS (TICKETS-CONTRACT-TRANSFER-HOLD-V1 v3 <auth> guest_link):
 * the GUEST BUYER's ownership proof — ref = the SOURCE order's
 * short_reference (ORD-XXXXXX), minted into the buyer's confirmation email.
 * It lets a buyer with no account START a transfer of their own ticket. It
 * is NOT a recipient claim link: nobody "receives" a ticket by opening it.
 *
 * HONEST PLACEHOLDER: the hold request needs source_ticket_id and
 * dest_ticket_type_id, and the token carries only the order ref.
 * CONTRACT GAP: there is no guest read endpoint (link-authenticated) that
 * lists the source order's tickets, so this landing cannot pick a
 * source_ticket_id (or its ticket_type_id) to hold. Until tickets defines
 * one, this renders a "link is valid — transfers via link open soon" card
 * plus Contact support. Nothing is fetched and nothing is fabricated.
 *
 * TOKEN HANDLING: the token lives in component state ONLY — never logged,
 * never written to localStorage/sessionStorage, never rendered. Per the
 * contract row it is forwarded UNCHANGED via TRANSFER_LINK_HEADER
 * (src/data/transfers.ts, auth `{ kind: 'link', token }`) instead of a
 * Bearer; my.trumin never mints or verifies it (tickets validates the
 * purpose-tagged HMAC link server-side).
 */
import { useState } from 'react'
import { Brand, Card } from '../components/ui'
import { supportMailtoHref } from '../data/support'
import { useLocale } from '../i18n/useLocale'

export function TransferLanding({ token }: { token: string }) {
  const { t } = useLocale()
  // Held for the contract-dependent hold call (see header). Intentionally
  // unread today.
  const [linkToken] = useState(token)
  void linkToken
  const support = supportMailtoHref()

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 16, boxSizing: 'border-box' }}>
      <div className="col" data-testid="transfer-landing" style={{ width: '100%', maxWidth: 400, gap: 18 }}>
        <div className="col" style={{ alignItems: 'center', gap: 10 }}>
          <Brand size={30} />
          <h1 style={{ fontSize: 20 }}>{t('transfer.landing.title')}</h1>
        </div>
        <Card>
          <div className="col" style={{ padding: 18, gap: 10, textAlign: 'center' }}>
            <p data-testid="transfer-landing-body" className="secondary" role="status" style={{ fontSize: 13, margin: 0 }}>
              {t('transfer.landing.body')}
            </p>
            {support && (
              <a data-testid="transfer-landing-support" href={support} style={{ fontSize: 13, fontWeight: 700, color: 'var(--tru-status-teal-bright)' }}>
                {t('transfer.contactSupport')}
              </a>
            )}
          </div>
        </Card>
      </div>
    </div>
  )
}
